// https://github.com/mui/material-ui/pull/23806
// useMediaQuery from mui is always returning false on first call
// this bug was fixed in 5.0.0 version
// Remove this function and use default useMediaQuery from mui on version upgrade
export default function useMediaQuery(mediaQuery: string): boolean {
  const [, query] = mediaQuery.split('@media');
  return window.matchMedia(query).matches;
}
